<template>
  <div class="recommendBox" style="">
    <div class="main">
    <mTitle :title="'农业新闻'" more="1"></mTitle>
    <div style="width: 100%;" class="swiperBox">
      <div>
        <el-carousel :interval="4000"   class="el-carousel" >
          <el-carousel-item v-for="(banner, index) in banners" :key="index">
            <img :src="banner.pic"
              class="swiperImg" />
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="newsBox">
        <div class="newsContentView" v-for="item in categories" @click="toPlaylistDetail(item.xid)">
          <div class="newLeftBox">
            <div  class="widBox">
              <div class="moonFont">{{item.day}}</div>
              <div class="yearFont">{{item.yearMonth}}</div>
            </div>
            

          </div>
          <div class="newRightBox">
            <div class="newsTitle">{{item.title}}</div>
            <div class="newsContent">{{removeHtmlTags(item.content)}}</div>
          </div>
        </div>

      </div>

    </div>
    <mTitle :title="'政策法规'" more="2"></mTitle> 
    <div class="margin15 pcBox" 
    >
      <el-table :data="list" style="width: 100%">
        <el-table-column type="index" label="序号" width="80">
        </el-table-column>
        <el-table-column prop="name" label="团体名称" width="180">
        </el-table-column>
        <el-table-column prop="title" label="标准名称" width="380">
        </el-table-column>
        <el-table-column prop="ref" label="标准编号">
        </el-table-column>
        <el-table-column prop="release" label="公布日期">
        </el-table-column>
        <el-table-column prop="address" label="操作" width="120">
          <template #default="{ row }">
            <el-button type="text" size="small" @click="toSingerDetail(row.xid)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="margin15 mobileBox">
      <div class="purchaseBox" v-for="item in list" @click="toSingerDetail(item.xid)">
        <div class="purchaseTitle">{{item.title}}</div>
        <div class="purchaseContent">
          <div class="lin20">团体名称：{{item.name}}</div>
          <div class="lin20">标准编号：{{item.ref}}</div>
          <div class="lin20">发布日期：{{item.release}}</div>
        </div>
      </div>
    </div>
    <mTitle :title="'科技推广'" more="3"></mTitle>
    <div class="believeBoxFlex">
      <div class="believeBox" v-for="item in mmsList" >
        <div class="believeImgBox">
          <img :src="item.pic"
            class="believeImg" />
        </div>
        <div class="believeTitle">{{item.title}}</div>
      </div>

    </div>
  </div>
  </div>

</template>

<script>

import mTitle from "@/components/TitleHead/index.vue";
export default {
  name: "Recommend",
  components: { mTitle },
  data() {
    return {
      tableData: [],
      banners: [],
      swiperOptions: {
        initialSlide: 0,
        slidesPerView: 5,
        slidesPerGroup: 5,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      topAlbum: [],
      newestAlbum: [],
      categories:[],
      mmsList:[],
      list:[]
    };
  },
  mounted() {
    // 获取轮播图数据
    this.$API.getBanner().then((res) => {
      console.log("res===========",res)
      if (res.code === 200) {
        console.log("22222222222",res)
        this.banners = res.data.list;
      }
    });
    this.getDynamics()
    this.getMmsList()
    this.getList()
    // // 新碟上架
    // this.$API.albumNewest().then((res) => {
    //   if (res.data.code === 200) {
    //     this.newestAlbum = res.data.albums.splice(0, 10);
    //   }
    // });

  },
  methods: {
    removeHtmlTags(str){
      return str.replace(/<[^>]*>/g, '');  // 正则表达式匹配所有HTML标签
    },
    getList(){
       this.$API.getStandard({currPage:1,pageSize:5}).then(res => {
      if (res.code === 200) {
        this.list = res.data.list
      }
    })
    },
    getMmsList(){
      this.$API.getMms({currPage:1,pageSize:4}).then(res => {
      if (res.code === 200) {
        this.mmsList = res.data.list
      }
    })
    },
    getDynamics(){
      this.$API.getCatlist({currPage:1,pageSize:6}).then(res => {
      if (res.code === 200) {
        this.categories = res.data.list
        this.categories.forEach(item =>{
          item.yearMonth = item.release.split("-")[0]+"-"+item.release.split("-")[1]
          item.day = item.release.split("-")[2]
        })
      }
    })
    },
    toSingerDetail(xid){
      this.$router.push({ path: "/singerDetail" ,query: { id: xid }});
    },
    toPlaylistDetail(xid) {
      this.$router.push({path:'/playlistDetail',query: { id: xid }})
    },
    changeMusiclist(list) {
      this.$bus.$emit("changeMusiclist", list);
    },
  },
};
</script>

<style scoped lang='less'>
.believeTitle{
  white-space: nowrap;        /* 防止换行 */
  overflow: hidden;           /* 隐藏超出部分 */
  text-overflow: ellipsis;    /* 显示省略号 */
}
//移动端
@media (max-width: 768px) {
  .believeTitle {
    height: 32px;
    background: #F7F7F7;
    padding: 0 10px;
font-weight: 500;
font-size: 16px;
color: #222222;
line-height: 32px;
text-align: center;
font-style: normal;
text-transform: none;
  }
  .believeImg {
    width: 90px;
    height: 90px;
    object-fit: contain;
  }
  .believeImgBox {
    height: 99px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .believeBox {
    width: 48%;
    height: 131px;
    background: #FFFFFF;
    border-radius: 5px 5px 5px 5px;
    border: 1px solid #DDDDDD;
    margin-top: 10px;
  }
  .believeBoxFlex {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .mobileBox{
    padding-top: 10px;
  }
  .lin20{
    margin-bottom: 10px;
  }
  .purchaseContent{
font-weight: 500;
font-size: 14px;
color: #7A7A7A;
text-align: left;
font-style: normal;
text-transform: none;
padding: 10px;
  }
  .purchaseTitle{
    border-bottom: 1px solid #E8E8E8;
    padding: 10px;
  }
  .purchaseBox{
    width: 100%;
height: 140px;
background: #F3F3F3;
border-radius: 5px 5px 5px 5px;
opacity: 0.9;
margin-bottom: 11px;
  }
  .newsBox{
    padding-bottom: 20px;
  }
  .pcBox{
    display: none;
  }
  .widBox{
    width: 52px;
    height: 52px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .newsContent {
    margin-top: 8px;

font-weight: 500;
font-size: 13px;
color: #7A7A7A;
line-height: 24px;
text-align: left;
font-style: normal;
text-transform: none;
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 溢出部分显示省略号 (...) */
  }

  .newsTitle {
font-weight: 800;
font-size: 16px;
color: #313131;
text-align: left;
font-style: normal;
text-transform: none;
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 溢出部分显示省略号 (...) */
  }
  .newRightBox {
    width: 85%;
    padding-left: 10px; /* 给右边内容留点空隙 */
  }
  .newsContentView {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
  }
  .moonFont {
    font-size: 16px;
  }

  .yearFont {
    font-size: 10px;
    margin-top: 3px;
  }
  .newLeftBox {
    background: #005431;
    color: #fff;

  }
  .main {
    padding: 14px;
    // display: flex;
    background-color: #fff;

  }
  .swiperBox {
    display: flex;
    padding-top: 16px;
    flex-direction: column;
  }
  ::v-deep .el-carousel__button {
    background: #222222;
    height: 5px;
    width: 20px;
    border-radius: 4px 4px 4px 4px;
  }

  ::v-deep .is-active .el-carousel__button {
    background: #0F6136 !important;
  }
  ::v-deep .el-carousel__container{
    height: 240px;
  }
  .el-carousel {
    width: 100%;
  margin: 0 auto;

}
.swiperImg {
  width: 100%;
    height: 240px;
  }
}

@media (min-width: 769px) {
  .recommendBox{
    width: 100%;
    background: #fff;
    padding-bottom: 20px;
  }
  .mobileBox{
    display: none;
  }
  .widBox{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  ::v-deep .el-carousel__container{
    height: 430px;
  }
  .el-carousel {
  width: 550px;
}
  .main {
    width: 1200px;
    margin: 0 auto;
    padding-top: 30px;
    // display: flex;
    background-color: #fff;

  }

  .believeBoxFlex {
    display: flex;
    flex-wrap: wrap;
    gap: 55px;
    margin-top: 15px;
  }

  .believeImgBox {
    height: 177px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .believeTitle {
    height: 50px;
    background: #F7F7F7;
    font-weight: 500;
    line-height: 50px;
font-size: 16px;
color: #222222;
text-align: center;
font-style: normal;
text-transform: none;
padding: 0 10px;
  }

  .believeImg {
    width: 200px;
    height: 140px;
    object-fit: contain;
  }

  .believeBox {
    width: 21%;
    height: 227px;
    background: #FFFFFF;
    border-radius: 5px 5px 5px 5px;
    border: 1px solid #DDDDDD;
  }

  .margin15 {
    margin: 15px 0 27px 0;
  }

  ::v-deep .el-button {
    font-weight: 500;
    font-size: 16px;
    color: #0F6136;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  ::v-deep .el-table__row .cell {
    font-weight: 500;
    font-size: 16px;
    color: #313131;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  ::v-deep .has-gutter .el-table__cell {
    background: #F7F7F7;
    font-weight: bold;
    font-size: 16px;
    color: #313131;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .newsContentView {
    display: flex;
    margin-bottom: 14px;
  }

  .swiperBox {
    display: flex;
    padding-top: 10px;
  }

  .newRightBox {
    margin-left: 10px;
    width: 546px;
  }

  .newsContent {
    font-weight: 500;
    font-size: 14px;
    color: #7A7A7A;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 10px;
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 溢出部分显示省略号 (...) */
  }

  .newsTitle {
    font-weight: 800;
    font-size: 16px;
    color: #313131;
    text-align: left;
    font-style: normal;
    text-transform: none;
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 溢出部分显示省略号 (...) */
  }

  .newsBox {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
  }

  .moonFont {
    font-size: 18px;
  }

  .yearFont {
    font-size: 12px;
    margin-top: 3px;
  }

  .newLeftBox {
    width: 60px;
    height: 60px;
    background: #005431;
    color: #fff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  ::v-deep .el-carousel__button {
    background: #222222;
    height: 5px;
    width: 20px;
    border-radius: 4px 4px 4px 4px;
  }

  ::v-deep .is-active .el-carousel__button {
    background: #0F6136 !important;
  }

  .swiperImg {
    width: 550px;
    height: 430px;
  }
}


</style>
